import React from 'react';
import {Form,FormGroup,  FormControl, Button} from 'react-bootstrap';
export default class Contact extends React.Component{

render(){
	return(
		
	    <Form inline method="POST" action="https://formspree.io/kmishra3@asu.edu">
		    <FormGroup controlId="formInlineName">
		      <FormControl name="name" type="text" placeholder="Jane Doe" />
		    </FormGroup>
		    {' '}
		    <FormGroup controlId="formInlineEmail" >
		      <FormControl type="email" name="_replyto" placeholder="jane.doe@example.com" />
		    </FormGroup>
		    <Button type="submit" bsStyle="primary">
		      Say Hi!
		    </Button>
		  </Form>  
		
    );
}
}


// WEBPACK FOOTER //
// ./src/Contact.js